export default [
  {
    label: "Neutral",
    value: "netural"
  },
  {
    label: "Minor",
    value: "minor"
  },
  {
    label: "Major",
    value: "major"
  },
  {
    label: "Critical",
    value: "critical"
  }
];